import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableFilterSheetDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    group: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    spaces
}: DataTableFilterSheetDynamicStyleType) => {
    const styles = {
        group: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
